import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "top-navigation-v2 sticky-top shadow-sm" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mx-3" }
const _hoisted_3 = { class: "d-flex p-1" }
const _hoisted_4 = ["selected"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "fi fi-gr fis" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "TH", -1)
const _hoisted_7 = ["selected"]
const _hoisted_8 = ["selected"]
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user text-primary me-2" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "ACCOUNT", -1)
const _hoisted_12 = { class: "navbar navbar-expand-lg navbar-light bg-white w-100 shadow-sm d-flex justify-content-between flex-column flex-lg-row" }
const _hoisted_13 = { class: "d-flex d-lg-none justify-content-between w-100 px-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  id: "public-logo",
  src: _imports_0
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_16 = { class: "d-none d-lg-flex justify-content-between px-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  id: "public-logo",
  src: _imports_0
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_19 = { class: "d-flex" }
const _hoisted_20 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_21 = { class: "navbar-nav text-primary d-flex justify-content-between" }
const _hoisted_22 = { class: "nav-item text-primary px-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h6", null, "UPDATE", -1)
const _hoisted_24 = { class: "nav-item px-4" }
const _hoisted_25 = { class: "nav-item text-primary px-4" }
const _hoisted_26 = { class: "nav-item px-4" }
const _hoisted_27 = { class: "nav-item px-4" }
const _hoisted_28 = { class: "d-flex position-relative" }
const _hoisted_29 = {
  class: "list-group position-absolute top-100 start-0 w-100",
  style: {"width":"25rem","z-index":"9999"}
}
const _hoisted_30 = ["onClick", "innerHTML"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fa-light fa-search" }, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "top-nav-separator me-3 d-none d-lg-block m-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_row = _resolveComponent("row")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("select", {
          class: "form-select py-0",
          "aria-label": "Default select example",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.commit('switchLanguage', $event.target.value)))
        }, [
          _createElementVNode("option", {
            value: "1",
            selected: _ctx.store.state.language==='th'
          }, [
            _createVNode(_component_row, null, {
              default: _withCtx(() => [
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            })
          ], 8, _hoisted_4),
          _createElementVNode("option", {
            value: "2",
            selected: _ctx.store.state.language==='en'
          }, "EN", 8, _hoisted_7),
          _createElementVNode("option", {
            value: "3",
            selected: _ctx.store.state.language==='ch'
          }, "CH", 8, _hoisted_8)
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_link, {
          class: "text-primary text-decoration-none",
          to: "/login"
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _hoisted_11
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("nav", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_router_link, {
          class: "navbar-brand",
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }),
        _hoisted_15
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_router_link, {
          class: "navbar-brand",
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }),
        _hoisted_18
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("ul", _hoisted_21, [
            _createElementVNode("li", _hoisted_22, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/update"
              }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_24, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/aboutus"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h6", null, _toDisplayString(_ctx.store.getters.localized('aboutus')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_25, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/product"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h6", null, _toDisplayString(_ctx.store.getters.localized('product')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_26, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/blog"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h6", null, _toDisplayString(_ctx.store.getters.localized('blog')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_27, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/contact"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h6", null, _toDisplayString(_ctx.store.getters.localized('contact')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_28, [
              (_ctx.showSearch)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event))
                  }, null, 512)), [
                    [_vModelText, _ctx.search]
                  ])
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docs, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "list-group-item",
                    onClick: ($event: any) => (_ctx.pushToSearch(item._id)),
                    innerHTML: _ctx.highlight(item)
                  }, null, 8, _hoisted_30))
                }), 256))
              ])
            ]),
            _createElementVNode("a", {
              class: "m-2",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.show && _ctx.show(...args)))
            }, _hoisted_32),
            _hoisted_33
          ])
        ])
      ])
    ])
  ]))
}